"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OKX_TG_WALLET = exports.OKX_APP_WALLET = exports.OKX_INJECT_WALLET = void 0;
exports.OKX_INJECT_WALLET = "okx_inject_wallet";
exports.OKX_APP_WALLET = "okx_app_wallet";
exports.OKX_TG_WALLET = "okx_tg_wallet";
